export default __webpack_public_path__ + "static/media/logo-alt.9b5eac88.svg";